import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "truncate" }
const _hoisted_2 = {
  key: 0,
  class: "hidden group-hover:flex items-center flex-shrink-0"
}
const _hoisted_3 = { class: "w-4 h-4 text-brand-800" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useNow } from '@/helpers/reactiveNow'
import { timeAgo } from '@/helpers/timeAgo'
import RemoveStarIcon from '@/icon/RemoveStarIcon'
import StarIcon from '@/icon/StarIcon'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'


export default {
  __name: 'SidebarConversation',
  props: {
  conversationUserPair: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const now = useNow()

const props = __props
const route = useRoute()

const starred = computed(() => props.conversationUserPair.attributes['favorited?'])
const unread = computed(() => props.conversationUserPair.attributes['has_unread?'])
const selected = computed(() => route.params.id === props.conversationUserPair.id)
const canUpdateMessages = computed(() => {
  return privilegeService.canAccessResourceAction('messages', null, 'update')
})

const relativeTime = computed(() => timeAgo(props.conversationUserPair.attributes.last_sent_timestamp, now.value))

const toggleStarred = () => {
  api.call(
    'POST',
    `conversation_user_pairs/${props.conversationUserPair.id}/${starred.value ? 'unfavorited' : 'favorited'}`
  )
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/messages/' + __props.conversationUserPair.id,
    class: _normalizeClass(["w-full transition-all duration-300 group flex items-center rounded-md px-3 py-1 text-sm tracking-tight text-gray-500 hover:bg-gray-50 hover:text-gray-900 truncate justify-between", {
      'bg-white': selected.value,
      'font-medium': !unread.value,
      'font-bold': unread.value
    }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.conversationUserPair.attributes.display_name), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["text-xs ml-auto flex-shrink-0", [selected.value ? 'text-gray-500' : 'text-gray-400', { 'group-hover:hidden': canUpdateMessages.value }]])
      }, _toDisplayString(relativeTime.value), 3),
      (canUpdateMessages.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              "aria-label": "Star Conversation",
              class: "mr-1",
              onClick: _withModifiers(toggleStarred, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_3, [
                (starred.value)
                  ? (_openBlock(), _createBlock(_unref(RemoveStarIcon), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(StarIcon), { key: 1 }))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

}